import { render, staticRenderFns } from "./succeed.vue?vue&type=template&id=e18dd898&scoped=true&"
import script from "./succeed.vue?vue&type=script&lang=js&"
export * from "./succeed.vue?vue&type=script&lang=js&"
import style0 from "./succeed.vue?vue&type=style&index=0&id=e18dd898&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18dd898",
  null
  
)

export default component.exports